import { isLocalDev } from "utils/isLocalDev";
import { NextPageContext } from "next";

export const getCountryCode = (req: NextPageContext["req"]) => {
  const localDev = isLocalDev();
  if (localDev) return process.env.COUNTRY_CODE || "US";

  const countryCodeHeader = req?.headers?.["x-country-code"] || "US";
  return Array.isArray(countryCodeHeader)
    ? countryCodeHeader[0]
    : countryCodeHeader;
};
